import React from "react"

import { DemandRequestOverlayView } from "./DemandRequestOverlayView"
import { useDemandRequestOverlayModel } from "./hooks/useDemandRequestOverlayModel"

type DemandRequestOverlayModel = ReturnType<typeof useDemandRequestOverlayModel>

export const DemandRequestOverlay = React.memo(
  (props: DemandRequestOverlayModel) => {
    return <DemandRequestOverlayView {...props} />
  }
)
